import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Card, Col, Row } from 'react-bootstrap';
import { Button } from '@sumologic/yama-ds-components';

import User from '~/models/User';

import Icon from '~/components/Icon/Icon';
import Translate from '~/components/Translate/Translate';
import AvatarBox from '~/components/AvatarBox/AvatarBox';
import TextualToggle from '~/components/TextualToggle/TextualToggle';

import PreferencesContext from '~/containers/Preferences/PreferencesContext';
import { checkFeatureFlag } from '../../../../../modules/helpers';
import Can from '../../../../../containers/Can/Can';

export const saveLastVisitedBetweenDashboardAndHome = str => {
    User.setPreferences('lastVisitedBetweenDashboardAndHome', {
        id: str
    });
};

export const secopsSection = 'home';
export const dashboardSection = 'dashboard';

const CardSidebarLeftTop = ({
    currentDashboard,
    homeDashboardActive,
    setHomeDashboardActive
}) => {
    const [avatar, setAvatar] = useState(null);

    const preferencesContext = useContext(PreferencesContext);

    useEffect(() => {
        const item = preferencesContext.avatar;
        if (item) {
            setAvatar(item);
        }
    }, [preferencesContext.avatar]);

    /*
    const [dashboardDropdownCurrentToggle, setDashboardDropdownCurrentToggle] = useState(false);
    const checkMenu = () => {
        return (
            !!APP_INFO.modules.licenseIms &&
            CURRENT_USER.isSuperUser === 0 &&
            User.can('dashboard_use')
            //!!CURRENT_USER.isMultiTenancyAdmin &&  //RN: after discussion with lz we decided to comment this check
        );
    };
    */

    const choose = str => {
        setHomeDashboardActive(str);
        saveLastVisitedBetweenDashboardAndHome(str);
    };

    const isHome = secopsSection === homeDashboardActive;
    const isDashboard = dashboardSection === homeDashboardActive;

    const { name, surname, mail, roles } = CURRENT_USER;
    return (
        <Card className="card-top fixed dashboard-dropdown-close">
            <Card.Header className="mb-2">
                <Row className="content">
                    <Col className="left">
                        <span className="nav">
                            {!!APP_INFO.modules.licenseIms &&
                                checkFeatureFlag('full_csoar') && (
                                    <>
                                        <TextualToggle
                                            className="me-2"
                                            active={isHome}
                                            onClick={
                                                isHome
                                                    ? null
                                                    : () => {
                                                          choose(secopsSection);
                                                      }
                                            }
                                        >
                                            <Translate message="SecOps" />
                                        </TextualToggle>
                                        <Can
                                            checkPermission={'dashboard_access'}
                                        >
                                            <>
                                                &nbsp;-&nbsp;
                                                <TextualToggle
                                                    className="ms-2"
                                                    active={isDashboard}
                                                    onClick={
                                                        isDashboard
                                                            ? null
                                                            : () => {
                                                                  choose(
                                                                      dashboardSection
                                                                  );
                                                              }
                                                    }
                                                >
                                                    <Translate message="Dashboard" />
                                                </TextualToggle>
                                            </>
                                        </Can>
                                    </>
                                )}
                        </span>
                        {/*
                        // 1/2, for when we have multiple dashboards:
                        <DropdownButton
                            className="scrollable"
                            title={
                                currentDashboard.name ||
                                `Dashboard ${currentDashboardIndex}`
                            }
                            disabled={dashboardsTotal < 2}
                            onSelect={eventKey => {
                                setCurrentDashboardIndex(parseInt(eventKey)); // str2num
                            }}
                            onToggle={setDashboardDropdownCurrentToggle}
                        >
                            {dashboardsTotal
                                ? dashboards.map((dashboard, index) => {
                                      //nb: 0 !== index -> can be deleted
                                      return index !== currentDashboardIndex ? (
                                          <Dropdown.Item
                                              key={index}
                                              eventKey={index}
                                          >
                                              {dashboard.name ||
                                                  `Dashboard ${index}`}
                                          </Dropdown.Item>
                                      ) : null;
                                  })
                                : null}
                        </DropdownButton>
                        */}
                    </Col>
                    <Col className="right">
                        {currentDashboard.isChanged ? (
                            <Button variant="text" onClick={() => {}}>
                                <Icon type="floppy-disk" />
                            </Button>
                        ) : null}
                        {/*
                        // 2/2, for when we have multiple dashboards:
                        <Button
                            variant="link"
                            onClick={() => {
                                openDialogAddWidget();
                            }}
                            disabled={showDialogAddWidget}
                        >
                            <Icon type="plus" />
                        </Button>
                        */}
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body>
                <AvatarBox
                    {...{
                        name,
                        surname,
                        mail,
                        roleName: roles.newStackProfile.roles
                            .map(e => e.value)
                            .join(',\u0020')
                    }}
                    img={avatar}
                />
            </Card.Body>
        </Card>
    );
};

CardSidebarLeftTop.propTypes = {
    dashboards: PropTypes.array.isRequired,
    currentDashboard: PropTypes.object.isRequired,
    currentDashboardIndex: PropTypes.number.isRequired,
    activeSection: PropTypes.string,
    setActiveSection: PropTypes.func
};

CardSidebarLeftTop.defaultProps = {
    currentDashboardIndex: 0
};

export default React.memo(CardSidebarLeftTop);
